<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        Dashboard
      </template>
      <template v-slot:right>
        <span v-if="$store.getters.isUserAdmin"
          ><BrandInput class="mt-3" v-model="globalBrand"></BrandInput>
        </span>
        <template v-else>
          <v-img
            v-if="$store.state.globalBrand['image_url']"
            :src="$store.state.globalBrand['image_url']"
            contain
            height="60"
            style="max-width:180px"
            class="rounded-md my-4"
          ></v-img>
          <v-img
            v-else
            src="@/assets/logo_black_no_text.png"
            contain
            height="60"
            style="max-width:180px"
            class="rounded-md my-4"
          ></v-img>
        </template>
      </template>
    </TopHeader>
    <v-row>
      <v-col>
        <PlaceholderWrapper
          :is-loading="loading.kpis || !isInit"
          :is-empty="kpis.length <= 0"
          empty-message="You don't have any counters to show"
          empty-icon="mdi-inbox"
          :empty-icon-size="40"
          :empty-message-size="17"
        >
          <template v-slot:mock>
            <v-row>
              <v-col cols="6">
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="100%"
                  max-height="170"
                  type="card"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="6">
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="100%"
                  max-height="170"
                  type="card"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="6">
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="100%"
                  max-height="170"
                  type="card"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="6">
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="100%"
                  max-height="170"
                  type="card"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </template>
          <template v-slot:content>
            <v-row>
              <v-col cols="6" v-for="(c, i) in kpis" :key="i">
                <v-card
                  class="kpi-card"
                  :color="c.selected ? 'accent lighten-2' : 'white'"
                  @click="handleCardSelect(i, c)"
                >
                  <v-card-title
                    :class="{
                      'white--text': c.selected,
                      'accent--text': !c.selected
                    }"
                    class="text-h5 font-weight-light"
                    >{{ c.title }}</v-card-title
                  >
                  <v-card-subtitle
                    :class="{
                      'white--text': c.selected,
                      'accent--text': !c.selected
                    }"
                    >{{ c.subtitle }}</v-card-subtitle
                  >
                  <v-card-text class="text-center">
                    <div
                      class="value mb-3 mt-2 font-weight-bold"
                      :class="{
                        'white--text': c.selected,
                        'accent--text': !c.selected
                      }"
                    >
                      {{ c.done }} <span v-if="c.cap">/ {{ c.cap }}</span>
                    </div>
                    <v-progress-linear
                      height="6"
                      rounded
                      :value="c.cap ? Math.floor((c.done / c.cap) * 100) : 100"
                      :color="c.color"
                      background-color="grey lighten-3"
                    ></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </PlaceholderWrapper>
      </v-col>
      <v-col cols="6">
        <v-card class="fill-height">
          <v-card-title class="accent--text font-weight-light">
            <v-icon left color="accent">mdi-bell-outline</v-icon>
            Notifications
          </v-card-title>
          <v-card-text>
            <PlaceholderWrapper
              :is-loading="loading.notifications"
              :is-empty="notifications.length <= 0"
              empty-message="You don't have any unread notifications at the moment"
              empty-icon="mdi-inbox"
              :empty-icon-size="40"
              :empty-message-size="17"
            >
              <template v-slot:content>
                <v-row class="mt-0">
                  <v-col
                    cols="12"
                    class="py-0"
                    v-for="(n, i) in notifications"
                    :key="i"
                  >
                    <Notification read-only dense :notification="n" />
                  </v-col>
                </v-row>
              </template>
            </PlaceholderWrapper>
            <div class="d-flex justify-center mt-4">
              <v-btn
                small
                text
                color="grey"
                :to="{ name: 'Notifications' }"
                link
              >
                <v-icon left class="mr-3">mdi-email-multiple-outline</v-icon>
                See all notifications
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="d-flex pb-2 flex-row justify-space-between flex-flow-column"
      >
        <div>
          <div class="text-h5">Products</div>
          <div class="subtitle-1 grey--text pl-1 mt-3 font-weight-light">
            {{ filteredProducts.length }} out of {{ products.length }} products
          </div>
        </div>
        <div>
          <span class="grey--text mr-10" style="opacity:.5">
            <v-icon left color="grey" small class="vertical-align-text-top"
              >mdi-filter</v-icon
            >
            Filter by
          </span>
          <span>
            <v-chip
              @click="handleSelectFilter('todo')"
              :color="
                productFilter.selected === 'todo' ? 'accent' : 'transparent'
              "
              class="mx-1"
            >
              todo
            </v-chip>
            <v-chip
              @click:close="clearCounterFilter"
              :close="
                !!(
                  filterProductsByCounter &&
                  filterProductsByCounter.value != 'unvalidated'
                )
              "
              :close-icon="
                filterProductsByCounter &&
                filterProductsByCounter.value != 'unvalidated'
                  ? 'mdi-close'
                  : ''
              "
              @click="handleSelectFilter('in progress')"
              :color="
                productFilter.selected === 'in progress'
                  ? 'accent'
                  : 'transparent'
              "
              class="mx-1"
              >in progress
              <span
                v-if="
                  filterProductsByCounter &&
                    filterProductsByCounter.value != 'unvalidated'
                "
              >
                &nbsp;: {{ filterProductsByCounter.title }}</span
              >
            </v-chip>
          </span>
        </div>
      </v-col>
    </v-row>
    <PlaceholderWrapper
      :is-loading="loading.products || !isInit"
      :is-empty="filteredProducts.length <= 0"
      empty-message="No products found"
      empty-icon="mdi-inbox"
      :empty-icon-size="40"
      :empty-message-size="17"
    >
      <template v-slot:content>
        <transition-group name="product" class="row" tag="div">
          <v-col
            cols="12"
            ld="2"
            md="3"
            sm="6"
            class="product"
            v-for="(p, i) in filteredProducts"
            :key="i"
          >
            <ProductCard :product="p" />
          </v-col>
        </transition-group>
      </template>
    </PlaceholderWrapper>
  </v-container>
</template>

<script>
import BrandInput from "@/components/inputs/BrandInput.vue"
import ProductCard from "@/components/perfumist/product/ProductCard"
import moment from "moment"
import PlaceholderWrapper from "@/components/base/PlaceholderWrapper"
import Notification from "@/components/base/Notification"
import TopHeader from "@/components/base/TopHeader.vue"
import { UtilService } from "@/services"
export default {
  components: {
    PlaceholderWrapper,
    TopHeader,
    Notification,
    ProductCard,
    BrandInput
  },
  computed: {
    isLoading() {
      for (let attr in this.loading) if (this.loading[attr]) return true
      return false
    },
    globalBrand: {
      get() {
        return this.$store.state.globalBrand
      },
      set(v) {
        this.$store.commit("setGlobalBrand", v)
      }
    },
    filterProductsByCounter() {
      let found = this.kpis.find(k => k.selected)
      return found ? found : null
    },
    filteredProducts() {
      let found = this.kpis.find(k => k.selected)
      return this.products.filter(p => {
        if (this.productFilter.selected == "in progress")
          if (found) {
            if (found.value.indexOf("_request") >= 0) {
              return found.value.toUpperCase().indexOf(p.status) >= 0
            } else {
              return !p.verified
            }
          } else {
            return !!p.status && p.verified
          }
        else return !p.verified
      })
    },
    notifications() {
      return this.$store.state.notifications.slice(0, 4)
    }
  },
  mounted() {
    if (!this.isLoading) this.init()
  },
  watch: {
    async "$store.state.globalBrand"(newValue, oldValue) {
      if (newValue) {
        this.init()
      }
    }
  },
  methods: {
    async init() {
      Promise.all([this.getProducts(), this.getStats()]).finally(r => {
        this.isInit = true
      })
    },
    handleSelectFilter(f) {
      this.productFilter.selected = f
      if (
        f == "in progress" &&
        this.filterProductsByCounter &&
        this.filterProductsByCounter.value == "unvalidated"
      )
        this.clearCounterFilter()
    },
    clearCounterFilter() {
      for (let i = 0; i < this.kpis.length; i++) this.kpis[i].selected = false
    },
    handleCardSelect(index, card) {
      for (let i = 0; i < this.kpis.length; i++) {
        this.kpis[i].selected = index == i
      }

      this.productFilter.selected =
        card.value == "unvalidated" ? "todo" : "in progress"
    },
    moment,
    limit(str) {
      const limit = 150
      if (str) return str.length > limit ? str.slice(0, limit) + "..." : str
      return ""
    },
    getStats() {
      if (!this.$store.state.globalBrand) return
      const $ = this
      return new Promise((resolve, reject) => {
        $.loading.kpis = true
        UtilService.dashboard_counters(this, $.$store.state.globalBrand.id)
          .then(r => {
            const stats = r.rows[0]
            $.kpis = [
              {
                value: "unvalidated",
                title: "Pending validations",
                selected: false,
                color: "teal",
                cap: stats.total,
                done: stats.total - stats.validated
              },
              {
                value: "edit_request,create_request",
                title: "Pending edits",
                selected: false,
                color: "accent",
                done: stats.edit_requests
              },
              {
                value: "delete_request",
                title: "Pending deletings",
                selected: false,
                color: "primary",
                done: stats.delete_requests
              },
              {
                value: "discontinuate_request",
                title: "Pending discontinuations",
                selected: false,
                color: "warning",
                done: stats.discontinuate_requests
              }
            ]
            resolve(r)
          })
          .catch(err => reject(err))
          .finally(() => {
            $.loading.kpis = false
          })
      })
    },
    getProducts() {
      if (!this.$store.state.globalBrand) return
      const $ = this
      return new Promise((resolve, reject) => {
        $.loading.products = true
        UtilService.unvalidated_products(this, $.$store.state.globalBrand.id)
          .then(r => {
            $.products = r.rows
            resolve(r)
          })
          .catch(err => reject(err))
          .finally(() => {
            $.loading.products = false
          })
      })
    }
  },
  data() {
    return {
      isInit: false,
      loading: {
        kpis: false,
        notifications: false,
        products: false
      },
      stats: {
        total: 0,
        validated: 0,
        edit_requests: 0,
        delete_requests: 0,
        discontinuate_requests: 0
      },
      productFilter: {
        values: ["todo", "in progress"],
        selected: "todo"
      },
      products: [],
      notificaitons: [],
      kpis: []
    }
  }
}
</script>

<style lang="scss">
.vertical-align-text-top {
  vertical-align: text-top !important;
}
.flex-flow-column {
  flex-flow: column;
}
.kpi-card {
  transition: 0.5s all;
  padding: 10px 15px 20px;
  .v-card__title {
    font-size: 24px !important;
    font-weight: 400 !important;
  }
  .v-card__text {
    .value {
      font-size: 22px;
    }
  }
}

.product {
  transition: all 0.5s;
}
.product-enter, .product-leave-to
/* .product-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
}
.product-enter-to {
  opacity: 1;
  transform: translateX(0px);
}
.product-leave-active {
  /*position: absolute;*/
}
.product-move {
  opacity: 1;
  transition: all 0.5s;
}
</style>
